var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastersActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#179CB9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.5H8a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-11a1 1 0 0 0-1-1zm0 1v3H8v-3h8zm-8 7v-3h8v3H8zm0 4v-3h8v3H8z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM9.5 12.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM9.5 16.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastersActiveIcon);
export default __webpack_public_path__ + "static/media/mastersActiveIcon.2b029123641cf4f22c046934de4ca03a.svg";
export { ForwardRef as ReactComponent };